export const SERVER_URL = window.location.origin.includes("localhost")
  ? "http://localhost:3011/"
  : "/";
